export default "__VITE_ASSET__DzuTvg1o__"